// var baseURL;
// var env = process.env.VUE_APP_ENV.trim();
// console.log(env);

// if (env === "production") baseURL = "https://mobile.photonowapp.com.br/";
// else if (env === "release") baseURL = "https://mobile.release.photonowapp.com/";
// else baseURL = "/";

const instagram_url = "https://instagram.photonowapp.com";

function getBaseUrl() {
  if (process.env.NODE_ENV === "production") {
    return "https://mobile.photonow.com.br/";
  } else {
    return "http://localhost:8081/";
  }
}

const baseURL = getBaseUrl();

export { baseURL, instagram_url };
